<template>
  <Skeleton v-if="loading" type="headline" />
  <component
    :is="tag"
    v-else
    v-bind="$attrs"
    data-test-id="headline"
    class="flex items-center gap-2 font-medium leading-tight"
    :class="{
      uppercase: isUppercase,
      'text-2xl': is2Xl,
      'text-xl': isXl,
      'text-lg': isLg,
      'text-base': isBase,
      'text-sm': isSm,
      'text-xs': isXs,
    }"
  >
    <slot />
    <slot :badge="badge" name="badge">
      <HeadlineBadge v-if="badge" :badge="badge" />
    </slot>
  </component>
</template>

<script setup lang="ts">
const props = defineProps({
  loading: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  isUppercase: {
    type: Boolean as PropType<boolean>,
    default: true,
  },
  badge: {
    type: [Number, String] as PropType<number | string>,
    default: 0,
  },
  size: {
    type: String as PropType<string>,
    default: '2xl',
    validator: (val: string) =>
      ['2xl', 'xl', 'lg', 'base', '2sm', 'sm', 'xs'].includes(val),
  },
  tag: {
    type: String as PropType<string>,
    default: 'h1',
    validator: (val: string) =>
      ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'div', 'span'].includes(val),
  },
})

const is2Xl = computed(() => props.size === '2xl')
const isXl = computed(() => props.size === 'xl')
const isLg = computed(() => props.size === 'lg')
const isBase = computed(() => props.size === 'base')
const isSm = computed(() => props.size === 'sm')
const isXs = computed(() => props.size === 'xs')
</script>
